<template>
  <transition name="fade">
    <div v-if="visible" class="update-notification">
      <div class="vx-row mb-4">
        <div class="vx-col w-full text-center">
          <img src="@/assets/images/logo/ITS-Logo.png" alt="" width="35%">
        </div>
      </div>
      <p class="message">
        Hi, it looks like we have updated our code whilst your page has been open. Please reload it before trying to use NIMBLE
      </p>
      <div>
        <vs-button @click="onReload" color="primary" class="mr-2">
          Reload
        </vs-button>
        <vs-button @click="onLater" color="danger" type="border" class="mr-2">
          Remind me in 1 min
        </vs-button>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onReload() {
      // window.location.reload(true);
      window.location.href = window.location.pathname + '?v=' + new Date().getTime();
    },
    onLater() {
      this.$emit("dismiss");
    }
  }
};
</script>

<style scoped>
/* Fade Animation */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

/* Notification Container */
.update-notification {
  position: fixed;
  bottom: 24px;
  right: 24px;
  width: 380px;
  background-color: #fefefe;
  border: 1px solid #d1d5db;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
  padding: 20px 24px;
  z-index: 9999;
  /* font-family: 'Segoe UI', sans-serif; */
  transition: transform 0.3s ease;
}

/* Text */
.message {
  color: #1f2937;
  font-size: 15px;
  margin: 0 0 16px 0;
  line-height: 1.5;
}
</style>
